import React, { useRef, useCallback, useEffect } from 'react';
import { TextField, IconButton, Box, Tooltip, InputAdornment, Typography, useTheme } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';

const CommonSearchField = ({
    placeholder,
    variant,
    size,
    inputProps = {},
    autoFocus,
    startAdornment,
    endAdornment,
    fullWidth,
    value,
    tooltipList = [],
    debounceMs = 600,
    handleSearch, // Destructure handleSearch directly
}) => {
    const theme = useTheme();
    const [searchTerm, setSearchTerm] = React.useState(value || "");
    const timerRef = useRef(null);

    // Cleanup timer on unmount
    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);

    const handleClear = useCallback(() => {
        setSearchTerm("");
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        if (handleSearch) {
            handleSearch("");
        }
    }, [handleSearch]);

    const handleChange = useCallback((ev) => {
        const newValue = ev.target.value;
        setSearchTerm(newValue);
        const val = (newValue || "").trim();
        
        // Clear previous timer
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        
        // Set new debounced timer
        timerRef.current = setTimeout(() => {
            if (handleSearch) {
                handleSearch(val);
            }
        }, debounceMs);
    }, [handleSearch, debounceMs]);

    return (
        <Box display="flex" alignItems="center">
            <Tooltip
                title={
                    tooltipList.length > 0 ? (
                        <Box>
                            <Typography variant="caption" gutterBottom>
                                You can search by :
                            </Typography>
                            <ul style={{ display: 'flex', flexWrap: 'wrap', paddingLeft: 20, margin: 0 }}>
                                {tooltipList?.map((item, index) => (
                                    <li key={index} style={{ width: '60%', }}>
                                        <Typography variant="caption">{item}</Typography>
                                    </li>
                                ))}
                            </ul>
                        </Box>
                    ) : (
                        "Enter search term"
                    )
                }
                arrow
            >
                <TextField
                    onChange={handleChange}
                    autoFocus={autoFocus}
                    value={searchTerm}
                    size={size || "small"}
                    type="text"
                    inputProps={{ maxLength: 50, ...inputProps }}
                    placeholder={placeholder || "Search"}
                    InputProps={{
                        startAdornment: startAdornment ? (
                            startAdornment
                        ) : (
                            <>
                                {/* <InputAdornment position="start">
                                    <img src={"images/SearchIcon.svg"} width="20px" height="20px" alt="Search Icon" />
                                </InputAdornment> */}
                                <SearchIcon fontSize='medium' sx={{ color: theme.palette.primary.main, mr: "5px" }} />
                            </>
                        ),
                        endAdornment: endAdornment ? (
                            endAdornment
                        ) : (
                            <InputAdornment position="end" sx={{ opacity: searchTerm ? 1 : 0 }}>
                                <IconButton style={{ padding: 2 }} onClick={handleClear}>
                                    <ClearIcon fontSize="small" color="disabled" />
                                </IconButton>
                            </InputAdornment>
                        ),
                        style: { borderRadius: 4 }
                    }}
                    variant={variant || "outlined"}
                    fullWidth={fullWidth}
                    sx={{
                        width: { xs: '100%', sm: '300px', },
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                        },
                    }}
                />
            </Tooltip>
        </Box>
    );
};

export default CommonSearchField;
